import React from 'react'
import GoogleSocialAuth from '../../components/GoogleSocialAuth'
import { Typography, Grid, Container } from '@material-ui/core'
import { useStyles } from './style'
import * as Image from './img'

const LoginPage = ({ handleLogin }) => {

    const classes = useStyles();

    return (
        <Container className={classes.root}>
            <Grid container direction="row" justifyContent="center" alignItems="center">
                <Grid item xs={12} className={classes.logoContainer}>
                    <Image.Logo />
                </Grid>
                <Grid item lg={12} className={classes.textContainer} container direction="row" justifyContent="center" alignItems="center">
                    <Grid item xs={10} lg={7} container direction="column">
                        <Typography className={classes.title} variant='h2'>Управление и мониторинг ваших инвестиций</Typography>
                        <Typography className={classes.paragraph} variant='h4'>&middot; Импортируйте отчёт брокера или добавляйте вручную акции и ETF</Typography>
                        <Typography className={classes.paragraph} variant='h4'>&middot; Анализируйте доходность портфеля по всем брокерам в одно месте</Typography>
                        <GoogleSocialAuth handleLogin={() => handleLogin()}/>
                    </Grid>
                    <Grid item className={classes.chart} lg={5}>
                        <Image.Chart />
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )
}

export default LoginPage;